import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { IconComponent } from '../../global/icon/icon.component';
import { IonicModule } from '@ionic/angular';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-big-msg-dialog',
    templateUrl: './big-msg-dialog.component.html',
    styleUrls: ['./big-msg-dialog.component.scss'],
    standalone: true,
    imports: [
        NgClass,
        NgIf,
        IconComponent,
        IonicModule,
        TranslatePipe,
    ],
})
export class BigMsgDialogComponent implements OnInit {
  @Input() is_no_padding: boolean = false;
  @Input() app_icon: string;
  @Input() ion_icon: string;
  @Input() text: string;
  @Input() btn_text: string;
  @Input() btn_class: string = 'bold';
  @Output() btn_callback = new EventEmitter<any>();
  @Input() btn_text_2: string;
  @Input() btn_class_2: string = 'no-border';
  @Output() btn_callback_2 = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {}

}
